module.exports = __webpack_public_path__ + "static/videoImage-16e66b5810d608bb47799a416befdfea.png";